module.exports = __webpack_public_path__ + "static/media/bamboo-frame.5fda0cf6.jpg";